import { logout } from '@ax/service';
import { LogoutInput } from '@ax/service/src/gwp-interface';
import { useMutation } from '@tanstack/react-query';

export function useLogout() {
  const logoutMutation = useMutation({
    mutationKey: ['logout'],
    mutationFn: (logoutDataInput: LogoutInput) => logout(logoutDataInput),
    onError: (error: any) => {
      console.log(error);
    },
  });
  return logoutMutation;
}
